import { createContext, useContext } from 'react';
import { assertContextValue } from './createContext';
import { WidgetsFormState } from '../state';

const context = createContext<WidgetsFormState | undefined>(undefined);

export const widgetsFormContext = context;
export const WidgetsFormContextProvider = context.Provider;
export const WidgetsFormContextConsumer = context.Consumer;

export const useWidgetsFormContext = () => {
  const value = useContext(context);
  assertContextValue('WidgetsFormContextProvider', value);
  return value;
};
